<template>
  <div class="editor-url">
    <div class="item">
      <span class="icon icon-compass2"></span>
      <span class="text"><input type="text" placeholder="动画编辑器URL" v-model="editor_url.editor_animation_url"></span>
    </div>
    <div class="item">
      <span class="icon icon-compass2"></span>
      <span class="text"><input type="text" placeholder="时间轴URL" v-model="editor_url.timeline_url"></span>
    </div>
    <div class="item">
      <span class="icon icon-compass2"></span>
      <span class="text"><input type="text" placeholder="PSocketUrl" v-model="editor_url.psocket_url"></span>
    </div>
    <div class="item">
      <div class="btn-save" @click="saveUrl">保存</div>
    </div>
  </div>
</template>

<script>

import EUY from '@/common/scripts/euy'
  export default {
    data () {
      return {
        editor_url: {
          editor_animation_url: '',
          timeline_url: '',
          psocket_url: ''
        },
        isDisabled: false
      }
    },
    methods: {
      saveUrl () {
        let editUrl = this.editor_url
        for (let i in editUrl) {
          if (editUrl[i] != '') {

            EUY.SetStorage('editor_url', editUrl)
          }
        }
        alert('保存成功')
      }
    },
    mounted () {
      let editorUrl = EUY.GetStorage('editor_url')
      if (editorUrl) {
        this.editor_url = editorUrl
      }
    }
  }
</script>

<style lang="stylus">
  .editor-url
    width: 800px
    margin: 20px auto
    .item
      position: relative
      margin: 10px
      padding-left: 40px
      &:last-child
        padding-left: 0
      span
        width: 100%
        input
          width: 100%
          color: #666
          border: 1px solid #eee
          padding: 0 10px
          height: 40px
          line-height: 40px
          font-size: 14px
          border-radius: 0 3px 3px 0
          box-sizing: border-box
          &:focus
            border: 1px solid #ccc
      .icon
        position: absolute
        top: 0
        left: 0
        width: 40px
        height: 40px
        line-height: 40px
        text-align: center
        background: #eee
        border-radius: 3px 0 0 3px
        font-size: 16px
        color: #666
      .btn-save
        width: 150px
        height: 35px
        line-height: 35px
        text-align: center
        border: 0
        color: #fff
        letter-spacing: 3px
        background: #0da3e2
        border-radius: 3px
        cursor: pointer
</style>



// WEBPACK FOOTER //
// EditorUrl.vue?69d6a822